import { render, staticRenderFns } from "./CheckDialog.vue?vue&type=template&id=8a5836f8&scoped=true&"
import script from "./CheckDialog.vue?vue&type=script&lang=ts&"
export * from "./CheckDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CheckDialog.vue?vue&type=style&index=0&id=8a5836f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5836f8",
  null
  
)

export default component.exports